"use client";

import clsx from "clsx";
import type { ComponentProps } from "react";

import type { GalleryItemData } from "@shared/content-types/types";
import { Image } from "@shared/ui/image";
import { InViewVideo } from "@shared/ui/video/video";

import s from "./gallery-item.module.scss";

export type GalleryItemProps = ComponentProps<"div"> & {
  className?: string;
  item: GalleryItemData;
};

export const GalleryItem = (props: GalleryItemProps) => {
  const { className, item } = props;

  if (item.type === "video" && item.video) {
    return (
      <div className={clsx(s.root, className)}>
        <InViewVideo
          src={item.video.url}
          className={clsx(s.media, s.video)}
          loop
          muted
          playsInline
        />
      </div>
    );
  }

  if (item.type === "image" && item.image) {
    return (
      <div className={clsx(s.root, className)}>
        <Image
          src={item.image.url || ""}
          alt="Gallery image"
          className={s.media}
          objectFit="cover"
          height="100%"
          width="100%"
        />
      </div>
    );
  }

  return null;
};

GalleryItem.displayName = "GalleryItem";
